module.exports = __webpack_public_path__ + "img/ser6.6528aa03.png";